
export const blogCategories = ['Productivity', 'Time Management', 'Work-Life Balance', 'Personal Development'];

export const blogPosts = [
  {
    id: 1,
    title: "The Science Behind the Pomodoro Technique",
    slug: "science-behind-pomodoro",
    author: "Dr. Sarah Mitchell",
    date: "2023-11-15",
    readTime: 8,
    category: "Productivity",
    tags: ["pomodoro", "productivity", "focus", "time management"],
    image: "https://images.unsplash.com/photo-1434030216411-0b793f4b4173",
    summary: "Discover the scientific principles that make the Pomodoro Technique so effective...",
    content: `
The Pomodoro Technique, developed by Francesco Cirillo in the late 1980s, has become one of the most popular time management methods worldwide. But what makes it so effective?

## The Psychology of Time Blocks

Research shows that our brains naturally operate in pulses, alternating between periods of high focus and low focus. The Pomodoro Technique's 25-minute work intervals align perfectly with these natural rhythms.

## The Role of Breaks

Regular breaks prevent mental fatigue and maintain high productivity levels throughout the day. Studies have shown that taking short breaks:
- Improves decision-making ability
- Enhances creativity
- Reduces mental fatigue
- Increases overall productivity

## Implementing the Technique

1. Choose a specific task
2. Set a timer for 25 minutes
3. Work with complete focus
4. Take a 5-minute break
5. Repeat the cycle

After completing four Pomodoros, take a longer 15-30 minute break to recharge fully.`
  },
  {
    id: 2,
    title: "Mastering the Art of Time Blocking",
    slug: "mastering-time-blocking",
    author: "James Wilson",
    date: "2023-11-12",
    readTime: 6,
    category: "Time Management",
    tags: ["time blocking", "planning", "productivity"],
    image: "https://images.unsplash.com/photo-1506784983877-45594efa4cbe",
    summary: "Learn how to effectively use time blocking to maximize your daily productivity...",
    content: `Time blocking is a powerful technique that can transform your productivity...`
  },
  {
    id: 3,
    title: "Why Multi-Tasking is a Myth",
    slug: "multi-tasking-myth",
    author: "Dr. Emily Chang",
    date: "2023-11-10",
    readTime: 10,
    category: "Productivity",
    tags: ["focus", "productivity", "myths"],
    image: "https://images.unsplash.com/photo-1499750310107-5fef28a66643",
    summary: "The truth about multi-tasking and why single-tasking is more effective...",
    content: `Recent studies have shown that what we call "multi-tasking" is actually...`
  },
  {
    id: 4,
    title: "Creating a Perfect Morning Routine",
    slug: "perfect-morning-routine",
    author: "Michael Brooks",
    date: "2023-11-08",
    readTime: 7,
    category: "Personal Development",
    tags: ["morning routine", "habits", "productivity"],
    image: "https://images.unsplash.com/photo-1506968430777-bf7784a87f23",
    summary: "Design a morning routine that sets you up for daily success...",
    content: `A well-designed morning routine can transform your entire day...`
  },
  {
    id: 5,
    title: "Digital vs. Analog Time Management",
    slug: "digital-vs-analog",
    author: "Lisa Chen",
    date: "2023-11-05",
    readTime: 9,
    category: "Time Management",
    tags: ["digital tools", "analog methods", "productivity"],
    image: "https://images.unsplash.com/photo-1506784365847-bbad939e9335",
    summary: "Comparing digital and analog time management methods...",
    content: `In our increasingly digital world, many still swear by analog methods...`
  },
  {
    id: 6,
    title: "Finding Work-Life Balance in a Remote World",
    slug: "remote-work-life-balance",
    author: "Alex Thompson",
    date: "2023-11-02",
    readTime: 8,
    category: "Work-Life Balance",
    tags: ["remote work", "balance", "wellbeing"],
    image: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d",
    summary: "Strategies for maintaining work-life balance while working remotely...",
    content: `The shift to remote work has blurred the lines between professional and personal life...`
  }
];
